import { gql } from '@apollo/client';

export const PLAN_FIELDS_FRAGMENT = gql`
  fragment PlanFields on Plan {
    objectId: id
    createdAt
    updatedAt
    countryCode
    planId
    planName
    isActive
    currency
    basePrice
    subscription
    freeTrialDays
    startingBalance
    resolutionCost
    messageCost
    seatCost
    prepayAmount
    criticalBalance
    minimumBalance
    planType
  }
`;
